// this file is a utility functions to extract card data from the Scryfall API response
// to reduce repetition in the code

export const extractCardData = (card) => {
  const face = Array.isArray(card.card_faces) ? card.card_faces[0] : {};

  return {
    frontImage: card.image_uris?.normal || face?.image_uris?.normal,
    backImage: card.card_faces?.[1]?.image_uris?.normal,
    manaCost: card.mana_cost || face?.mana_cost || '',
    typeLine: card.type_line || face?.type_line || '',
    oracleText: card.oracle_text || face?.oracle_text || '',
    rarity: card.rarity || '',
    setName: card.set_name || card.set, // fallback to code if name missing
    artist: card.artist || face?.artist || '',
    flavorText: card.flavor_text || face?.flavor_text || '',
  };
};